export interface Match {
  id: string;
  tournamentId: string;
  homeTeamName: string;
  awayTeamName: string;
  homeTeamRegistrationId: string | null;
  awayTeamRegistrationId: string | null;
  homeScore: number | null;
  awayScore: number | null;
  /** Null for draft matches */
  scheduledAt: string | null;
  /** FK to Branch. Null for draft matches */
  branchId: string | null;
  /** Denormalized branch name for display */
  branchName: string | null;
  /** 'draft' | 'upcoming' | 'live' | 'completed' */
  status: string;
  /** 'Group Stage' | 'Knockout' | 'Quarter-finals' | 'Semi-finals' | 'Final' */
  stage: string | null;
  groupId: string | null;
  groupName: string | null;
  notes: string | null;
  bracketPosition: number | null;
  nextMatchId: string | null;
}

export interface CreateMatchRequest {
  tournamentId: string;
  homeTeamName: string;
  awayTeamName: string;
  homeTeamRegistrationId?: string | null;
  awayTeamRegistrationId?: string | null;
  scheduledAt?: string | null;
  branchId?: string | null;
  stage?: string | null;
  groupId?: string | null;
  notes?: string | null;
  bracketPosition?: number | null;
  nextMatchId?: string | null;
}

export interface UpdateMatchRequest {
  homeScore?: number | null;
  awayScore?: number | null;
  status?: string | null;
  scheduledAt?: string | null;
  branchId?: string | null;
  stage?: string | null;
  notes?: string | null;
  bracketPosition?: number | null;
  nextMatchId?: string | null;
}

export interface GenerateGroupMatchesRequest {
  tournamentId: string;
  groupName: string;
  teamRegistrationIds: string[];
  stage: string;
}

export const MATCH_STAGES = [
  'Group Stage',
  'Knockout',
  'Quarter-finals',
  'Semi-finals',
  'Final'
] as const;

export const MATCH_STATUSES = ['draft', 'upcoming', 'live', 'completed'] as const;
